export const getSubscriptionString = (str) => {
  if (str === "basic_notice_service") return "6-Beacon Add-On";
  if (str === "basic_notice_service_monthly") return "6-Beacon Add-On";
  if (str === "basic_notice_service_yearly") return "6-Beacon Add-On";

  if (str === "group_service") return "Group Service";
  if (str === "group_service_yearly") return "Group Service";
  if (str === "group_service_monthly") return "Group Service";

  if (str === "notice_service") return "9-Beacon Add-On";
  if (str === "notice_service_month") return "9-Beacon Add-On";
  if (str === "notice_service_year") return "9-Beacon Add-On";

  if (str === "very_basic_notice_service") return "1-Beacon Add-On";
  if (str === "very_basic_notice_service_monthly") return "1-Beacon Add-On";
  if (str === "very_basic_notice_service_yearly") return "1-Beacon Add-On";

  if (str === "medium_basic_notice_service") return "3-Beacon Add-On";
  if (str === "medium_basic_notice_service_monthly") return "3-Beacon Add-On";
  if (str === "medium_basic_notice_service_yearly") return "3-Beacon Add-On";

  return "";
};
